import { Grid, Typography, useTheme } from "@mui/material";
import { TextInputField } from "./UserInput";

interface propsTypes {
  label: string;
  value: string;
  type: string;
  inputPlaceHolder: string;
  onInputChange: (data: any) => void;
  options?: any;
}

interface DualProps {
  label: string;
  fromTitle: string;
  toTitle: string;
  fromValue: string;
  toValue: string;
  fromOnChange: (data: any) => void;
  toOnChange: (data: any) => void;
  type: string;
}

const InputProps = (props: propsTypes) => {
  const { label, value, type, inputPlaceHolder, onInputChange, options } =
    props;
  const theme = useTheme();
  return (
    <Grid borderBottom={theme.border?.smallGrey} mt={3}>
      <Typography
        sx={{
          fontFamily: theme.font?.fontFamily.primary,
          fontSize: theme.font?.fontSize.medium,
          fontWeight: theme.font?.fontWeight.thick,
        }}
      >
        {label}
      </Typography>
      <Grid display={"flex"} gap={2} mt={2}>
        <TextInputField
          styles={{
            display: "flex",
            width: "180%",
          }}
          type={type}
          inputPlaceHolder={inputPlaceHolder}
          value={value}
          onInputChange={(e) => onInputChange(e)}
          tittle={label}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

export const DualInputProps = (props: DualProps) => {
  const {
    label,
    fromTitle,
    toTitle,
    type,
    fromOnChange,
    toOnChange,
    fromValue,
    toValue,
  } = props;
  const theme = useTheme();
  return (
    <Grid borderBottom={theme.border?.smallGrey} mt={3}>
      <Typography
        sx={{
          fontFamily: theme.font?.fontFamily.primary,
          fontSize: theme.font?.fontSize.medium,
          fontWeight: theme.font?.fontWeight.thick,
        }}
      >
        {label}
      </Typography>
      <Grid display={"flex"} gap={2} mt={1} direction={"row"}>
        <TextInputField
          styles={{
            display: "flex",
            width: "50%",
          }}
          type={type}
          inputPlaceHolder={fromTitle}
          value={fromValue}
          onInputChange={fromOnChange}
        />
        <TextInputField
          styles={{
            display: "flex",
            width: "50%",
          }}
          type={type}
          value={toValue}
          inputPlaceHolder={toTitle}
          onInputChange={toOnChange}
        />
      </Grid>
    </Grid>
  );
};
export default InputProps;
